/**
 * Which bot message is "the latest results".
 *
 * Only the latest results-bearing message keeps its rows live: it merges the
 * cumulative order, and its rows stay editable (Refine). Older tables freeze to
 * their own snapshot, and a newer user message freezes everything before it.
 *
 * "Results" is anything the results view renders — found cards, a settled
 * ledger turn, or plain misses. A turn that confirmed nothing is still the
 * latest results, otherwise its unresolved rows could never be refined.
 */

type ResultsMessage = {
  sender: string;
  parts_results?: unknown[] | null;
  not_found_parts?: unknown[] | null;
  turn_lines?: unknown[] | null;
};

export const rendersResults = (m: ResultsMessage): boolean =>
  m.sender === 'bot' && (
    ((m.parts_results?.length ?? 0) > 0)
    || ((m.turn_lines?.length ?? 0) > 0)
    || ((m.not_found_parts?.length ?? 0) > 0)
  );

export const isLatestResultsAt = (messages: ResultsMessage[], index: number): boolean => {
  const message = messages[index];
  if (!message || !rendersResults(message)) return false;
  const later = messages.slice(index + 1);
  return !later.some(rendersResults) && !later.some(m => m.sender === 'user');
};
